"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessProcessEvent = void 0;
var BusinessProcessEvent = /** @class */ (function () {
    function BusinessProcessEvent(businessProcessName, componentType, startDateTime, endDateTime, templateType) {
        this.BusinessProcessName = businessProcessName;
        this.eventName = businessProcessName;
        this.ComponentType = componentType;
        this.startDateTime = startDateTime;
        this.endDateTime = endDateTime;
        if (typeof this.templateType != 'undefined') {
            this.templateType = templateType;
        }
        else {
            this.templateType = "Internal.BusinessProcessEvent";
        }
    }
    Object.defineProperty(BusinessProcessEvent.prototype, "BusinessProcessName", {
        get: function () {
            return this.businessProcessName;
        },
        set: function (value) {
            this.businessProcessName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "TargetEntityKey", {
        get: function () {
            return this.targetEntityKey;
        },
        set: function (value) {
            this.targetEntityKey = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "ActionUri", {
        get: function () {
            return this.actionUri;
        },
        set: function (value) {
            this.actionUri = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "AppAction", {
        get: function () {
            return this.appAction;
        },
        set: function (value) {
            this.appAction = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "EventType", {
        get: function () {
            return this.eventType;
        },
        set: function (value) {
            this.eventType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "TemplateType", {
        get: function () {
            return "Internal.BusinessProcessEvent";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "ComponentType", {
        get: function () {
            return this.componentType;
        },
        set: function (value) {
            this.componentType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "Xcv", {
        get: function () {
            return this.xcv;
        },
        set: function (value) {
            this.xcv = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "UserRoleName", {
        get: function () {
            return this.userRoleName;
        },
        set: function (value) {
            this.userRoleName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "StartDateTime", {
        get: function () {
            return this.startDateTime;
        },
        set: function (value) {
            this.startDateTime = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "EndDateTime", {
        get: function () {
            return this.endDateTime;
        },
        set: function (value) {
            this.endDateTime = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "EventName", {
        get: function () {
            return this.eventName;
        },
        set: function (value) {
            this.eventName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "SenderId", {
        get: function () {
            return this.senderId;
        },
        set: function (value) {
            this.senderId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "ReceiverId", {
        get: function () {
            return this.receiverId;
        },
        set: function (value) {
            this.receiverId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "MessageId", {
        get: function () {
            return this.messageId;
        },
        set: function (value) {
            this.messageId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessProcessEvent.prototype, "EventOccurrenceTime", {
        get: function () {
            return this.eventOccurenceTime;
        },
        set: function (value) {
            this.eventOccurenceTime = value;
        },
        enumerable: false,
        configurable: true
    });
    BusinessProcessEvent.prototype.IsValidEvent = function (isValid) {
        if (!isValid) {
            if (!this.businessProcessName || 0 === this.businessProcessName.length) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return ((typeof this.appAction != "undefined" && 0 !== this.appAction.length) && (typeof this.businessProcessName != "undefined" && 0 !== this.businessProcessName.length) && (typeof this.receiverId != "undefined" && 0 !== this.receiverId.length) && (typeof this.senderId != "undefined" && 0 !== this.senderId.length) && (typeof this.eventOccurenceTime != "undefined"));
        }
    };
    return BusinessProcessEvent;
}());
exports.BusinessProcessEvent = BusinessProcessEvent;
//# sourceMappingURL=BusinessProcessEvent.js.map